import { Bot } from "lucide-react";
import { useAuth } from "context/AuthContext";
import { useAssistantIdentity } from "hooks/useAssistantIdentity";
import { contactListItemClasses } from "utils/contactListItemClasses";

interface ManagerInstructionsSectionProps {
  selected: boolean;
  onSelect: () => void;
}

export function ManagerInstructionsSection({
  selected,
  onSelect,
}: ManagerInstructionsSectionProps) {
  const { isImpersonating, impersonatedManager, lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  const { assistantName } = useAssistantIdentity();

  if (!isImpersonating) {
    return null;
  }

  const managerName = impersonatedManager?.contact.name?.trim();

  return (
    <div className="mb-4 border-b border-red-200 pb-4">
      <h3 className="mb-2 flex items-center text-xs font-semibold uppercase tracking-wide text-red-700">
        <Bot className="mr-2 h-4 w-4" aria-hidden />
        {locale === "es" ? "Modo soporte" : "Support mode"}
      </h3>
      <button
        type="button"
        onClick={onSelect}
        className={`w-full text-left ${contactListItemClasses(selected)}`}
      >
        <div className="font-medium text-gray-900">
          {locale === "es"
            ? `Instrucciones a ${assistantName}`
            : `Instructions to ${assistantName}`}
        </div>
        {managerName && (
          <div className="mt-0.5 truncate text-xs text-gray-500">
            {locale === "es"
              ? `Como ${managerName}`
              : `As ${managerName}`}
          </div>
        )}
      </button>
    </div>
  );
}
